import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useDispatch } from "react-redux";
import { MdRemoveCircle, MdAddCircle } from "react-icons/md";
import {
  Button,
  Checkbox,
  Col,
  DatePicker,
  Form,
  Input,
  Row,
  Select,
} from "antd";
import { numberType, salutation } from "../../../../../../utils/tenants";
import SubHeading from "../../../../../../components/common/SubHeading";
import WarningMessage from "../../../../../../components/common/WarningMessage";
import "./Profile.css";
import { useNavigate } from "react-router-dom";
import { db, auth } from "../../../../../../firebase";
import {
  collection,
  addDoc,
  doc,
  query,
  where,
  getDocs,
  updateDoc,
  getDoc,
} from "firebase/firestore";
import dayjs from "dayjs";
import {
  SelectMoveInTenantInfo,
  setProfileInformation,
  setTenantData,
} from "../../../../../../store/moveInTenantSlice";
import { useAuthState } from "react-firebase-hooks/auth";
import { useSelector } from "react-redux";
import axios from "axios";

function Profile({ current, setCurrent }) {
  const [errorMessage, setErrorMessage] = useState(false);
  const [emails, setEmails] = useState([{ id: 1, email: "" }]);
  const [phoneNumbers, setPhoneNumbers] = useState([
    { id: 1, type: "", phoneNumber: "", details: "" },
  ]);
  const [user, loading] = useAuthState(auth);
  const [companyName, setcompanyName] = useState("");
  const [isWait, setIsWait] = useState(false);

  const tenantData = useSelector(SelectMoveInTenantInfo);
  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user.uid));

      getDocs(userData)
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            const res = doc.data();
            setcompanyName(res.companyName);
          });
        })
        .catch((error) => {
          console.log("Error getting users: ", error);
        });
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const navigate = useNavigate();
  const currentDate = dayjs();
  const dispatch = useDispatch();

  const next = () => {
    setCurrent(current + 1);
  };

  const addPhoneNumber = () => {
    const newPhoneNumber = {
      id: phoneNumbers.length + 1,
      type: "",
      phoneNumber: "",
      addiotionalDetails: "",
    };
    setPhoneNumbers([...phoneNumbers, newPhoneNumber]);
  };

  const removePhoneNumber = (id) => {
    const updatedPhoneNumbers = phoneNumbers.filter(
      (phoneNumber) => phoneNumber.id !== id
    );
    setPhoneNumbers(updatedPhoneNumbers);
  };

  const handleTypeChange = (value, name, id) => {
    const updatedPhoneNumbers = phoneNumbers.map((phoneNumber) => {
      if (phoneNumber.id === id) {
        return { ...phoneNumber, [name]: value };
      }
      return phoneNumber;
    });
    setPhoneNumbers(updatedPhoneNumbers);
  };

  const addEmail = () => {
    const newEmail = { id: emails.length + 1, email: "" };
    setEmails([...emails, newEmail]);
  };

  const removeEmail = (id) => {
    const updatedEmails = emails.filter((email) => email.id !== id);
    setEmails(updatedEmails);
  };

  const handleEmailChange = (e, id) => {
    const updatedEmails = emails.map((email) => {
      if (email.id === id) {
        return { ...email, email: e.target.value };
      }
      return email;
    });
    setEmails(updatedEmails);
    setErrorMessage(false);
  };

  const handleFormSubmit = async (values) => {
    setIsWait(true);
    Object.keys(values).forEach((field) => {
      if (values[field] === undefined) {
        values[field] = "";
      }
    });
    const filteredPhoneNumbers = phoneNumbers.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    console.log("filtered phoneNumbers", phoneNumbers);

    const filteredEmails = emails.filter((item) => {
      return Object.keys(item).some((key) => key !== "id" && item[key] !== "");
    });

    const profileInfo = {
      salutation: values.tenantSalutation,
      firstName: values.tenantFirstName,
      middleName: "",
      lastName: values.tenantLastName,
      companyName: values.tenantCompany,
      companyNameAsDisplay: values.companyNameAsDisplay,
      ref_tenant_id: "",
    };

    const contact = {
      emails: filteredEmails,
      phoneNumbers: filteredPhoneNumbers,
      addresses: [],
    };

    const tenantStatus = {
      tenantType: "",
      moveInDate: values.moveInDate.format("YYYY-MM-DD"),
      moveOutDate: "",
      noticeDate: "",
    };

    const screening = {
      dateOfBirth: "",
      driverLicense: "",
      state: "",
      ssn: "",
      creditReportDate: "",
      CreditScore: "",
    };

    const emergencyContact = {
      name: "",
      address: "",
      phoneNumber: "",
      emailAddress: "",
      relationship: "",
    };

    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, companyName);
    const tenantRef = collection(companyDocRef, "tenants");

    if (tenantData.tenantId) {
      const tenantRef = doc(
        db,
        "companies",
        companyName,
        "tenants",
        tenantData.tenantId
      );

      getDoc(tenantRef)
        .then((docSnapshot) => {
          if (docSnapshot.exists()) {
            const data = docSnapshot.data();
            console.log("Document data:", data);
            // Perform further operations with the retrieved data
            const mergedArr = data.contact.phoneNumbers
              .concat(filteredPhoneNumbers)
              .map((item, index) => ({
                ...item,
                id: index + 1, // Generate unique IDs starting from 1
              }));

            try {
              updateDoc(tenantRef, {
                "profileInfo.salutation": values.tenantSalutation,
                "profileInfo.firstName": values.tenantFirstName,
                "profileInfo.middleName": "",
                "profileInfo.lastName": values.tenantLastName,
                "profileInfo.companyName": values.tenantCompany,
                "profileInfo.companyNameAsDisplay": values.companyNameAsDisplay,
                "contact.phoneNumbers": mergedArr,
                "contact.emails": data.contact.emails.concat(filteredEmails),
              });
              console.log("Tenant created successfully");
              // setIsWait(false);
            } catch (err) {
              console.error(err);
              alert(err.message);
              setIsWait(false);
            }
          } else {
            console.log("No such document exists!");
            setIsWait(false);
          }
        })
        .catch((error) => {
          console.error("Error retrieving document:", error);
          setIsWait(false);
        });
    }

    if (!tenantData.tenantId) {
      try {
        const tentInfo = await addDoc(tenantRef, {
          profileInfo,
          contact,
          tenantStatus,
          screening,
          emergencyContact,
        });
        console.log("Tenant created successfully");
        await dispatch(setTenantData(tentInfo.id));

        const usersRef = collection(db, "allUsers");
        try {
          const querySnapshot = await getDocs(
            query(usersRef, where("email", "==", filteredEmails[0].email))
          );
          if (querySnapshot.size > 0) {
            toast.error("Email already taken.");
            setIsWait(false)
            setErrorMessage(true);
          } else {
            const userData = {
              email: filteredEmails[0].email,
              firstName: values.tenantFirstName,
              lastName: values.tenantLastName,
              role: "tenant",
              companyName: companyName,
              tenantId: tentInfo.id,
            };
            console.log("tenantData:", tenantData);
            try {
              const response = await axios.post(
                "https://us-central1-sayeagle-77c75.cloudfunctions.net/api/tenant-user",
                userData
              );
              console.log(response.data); // User created successfully
              toast.success("user created successfully");
              next();
            } catch (error) {
              console.error("Error creating user:", error);
              const errorMessage = error.message;
              toast.error(errorMessage);
            setIsWait(false)
            }
          }
        } catch (error) {
          const errorMessage = error.message;
          toast.error(errorMessage);
          setIsWait(false)
        }
      } catch (err) {
        console.error(err);
        alert(err.message);
      }
    }

    dispatch(
      setProfileInformation({
        firstName: values.tenantFirstName,
        lastName: values.tenantLastName,
        emails: emails,
        phoneNumbers: phoneNumbers,
      })
    );

  
  };

  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };

  const initialValues = {
    moveInDate: currentDate,
  };

  console.log("email", emails);

  return (
    <div className="profile">
      <SubHeading subHeading="Profile Information" />
      <Row gutter={[0, 10]}>
        <Col span={24}>
          <WarningMessage message="A screening report is not detected for this tenant." />
        </Col>
        <Col span={24}>
          <p>
            Enter information for the Primary Tenant, then click Continue. To
            add an additional tenant, click the Add Tenant button below.
          </p>
        </Col>
        <Col span={24}>
          <Form
            layout="vertical"
            onFinish={handleFormSubmit}
            onFinishFailed={onFinishFailed}
            initialValues={initialValues}
          >
            <Row gutter={[0, 10]}>
              <Col span={24}>
                <p>
                  <strong>Name</strong>
                </p>
                <Row gutter={[6, 0]}>
                  <Col>
                    <Form.Item label="Salutation" name="tenantSalutation">
                      <Select
                        options={salutation}
                        placeholder="Select salutation"
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item
                      label="First"
                      required
                      name="tenantFirstName"
                      rules={[
                        { required: true, message: "First Name is required" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item
                      label="Last"
                      required
                      name="tenantLastName"
                      rules={[
                        { required: true, message: "Last Name is required" },
                      ]}
                    >
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
              <Col span={8}>
                <Form.Item label="Compnay" name="tenantCompany">
                  <Input />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item name="companyNameAsDisplay" valuePropName="checked">
                  <Checkbox>Use Company Name as display name</Checkbox>
                </Form.Item>
              </Col>
              <Col span={24}>
                <hr />
              </Col>
              <Col span={24}>
                <p>
                  <strong>Phone Numbers</strong>
                </p>
                {phoneNumbers?.map((item, index) => {
                  return (
                    <Row gutter={[6, 0]} key={index}>
                      <Col>
                        <Form.Item label="Type" name={`type${index}`}>
                          <Select
                            options={numberType}
                            placeholder="Select type"
                            value={item.type}
                            onChange={(value) =>
                              handleTypeChange(value, "type", item.id)
                            }
                          />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item label="Number" name={`number${index}`}>
                          <Input
                            onChange={(e) =>
                              handleTypeChange(
                                e.target.value,
                                "phoneNumber",
                                item.id
                              )
                            }
                            value={item.phoneNumber}
                          />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item label=" ">
                          <MdAddCircle
                            style={{ color: "#008a00" }}
                            onClick={() => addPhoneNumber()}
                            size={20}
                          />
                        </Form.Item>
                      </Col>
                      {phoneNumbers.length > 1 && (
                        <Col>
                          <Form.Item label=" ">
                            <MdRemoveCircle
                              style={{ color: "#de1414" }}
                              onClick={() => removePhoneNumber(item.id)}
                              size={20}
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  );
                })}
              </Col>
              <Col span={24}>
                <hr />
              </Col>
              <Col span={24}>
                <p>
                  <strong>Emails</strong>
                </p>
                {emails.map((item, index) => {
                  return (
                    <Row gutter={[6, 0]} key={index}>
                      <Col>
                        <Form.Item
                          label="Email"
                          name={`email${index}`}
                          validateStatus={
                            errorMessage && item.id === 1 ? "error" : null
                          }
                          help={
                            errorMessage && item.id === 1
                              ? "Email already taken. Please use a different email address."
                              : null
                          }
                          rules={[
                            {
                              required: item.id === 1 ? true : false,
                              message: "Please input user email address!",
                            },
                          ]}
                        >
                          <Input
                            onChange={(e) => handleEmailChange(e, item.id)}
                            value={item.email}
                          />
                        </Form.Item>
                      </Col>
                      <Col>
                        <Form.Item label=" ">
                          <MdAddCircle
                            style={{ color: "#008a00" }}
                            onClick={() => addEmail()}
                            size={20}
                          />
                        </Form.Item>
                      </Col>
                      {emails.length > 1 && (
                        <Col>
                          <Form.Item label=" ">
                            <MdRemoveCircle
                              style={{ color: "#de1414" }}
                              onClick={() => removeEmail(item.id)}
                              size={20}
                            />
                          </Form.Item>
                        </Col>
                      )}
                    </Row>
                  );
                })}
              </Col>
              <Col span={24}>
                <hr />
              </Col>
              <Col span={24}>
                <Form.Item
                  label="Move In"
                  required
                  name="moveInDate"
                  rules={[
                    { required: true, message: "Move in date is required" },
                  ]}
                >
                  <DatePicker />
                </Form.Item>
              </Col>
              <Col span={24}>
                <hr />
              </Col>
              <Col span={24}>
                <Row justify="space-between">
                  <Col>
                    <Button type="primary" onClick={() => next()}>
                      Add Tenant
                    </Button>
                  </Col>
                  <Col>
                    <Row gutter={[8, 0]}>
                      <Col>
                        <Button
                          type="primary"
                          htmlType="submit"
                          disabled={isWait}
                        >
                          {isWait ? "wait..." : "Continue"}
                        </Button>
                      </Col>
                      <Col>
                        <Button type="link" onClick={() => navigate("/")}>
                          Cancel Move In
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default Profile;
